export default "__VITE_ASSET__CtjzuDZ5__"